import React, { useRef, useState } from 'react'

import { HiOutlineCheck, HiOutlineClipboard } from 'react-icons/hi2'
import { toast } from 'sonner'
import { twMerge } from 'tailwind-merge'

import { useHandleError } from '@/hooks/common/useErrorHandler'

interface Table extends React.HTMLProps<HTMLTableElement> {
  isHeader?: boolean
  node?: any
}

export const Table: React.FC<Table> = ({
  children,
  isHeader,
  node,
  ...props
}) => {
  const { handleError } = useHandleError()
  const tableRef = useRef<HTMLTableElement | null>(null)
  const [isCopied, setIsCopied] = useState<boolean>(false)

  const onCopy = async () => {
    if (tableRef.current) {
      try {
        const clipboardItem = new ClipboardItem({
          'text/html': new Blob([tableRef.current.outerHTML], {
            type: 'text/html',
          }),
        })
        await navigator.clipboard.write([clipboardItem])
        toast.success('Table copied to clipboard!')
        setIsCopied(true)
        setTimeout(() => setIsCopied(false), 3000)
        return true
      } catch (err) {
        handleError(err)
        setIsCopied(false)
        return false
      }
    }
    return false
  }

  return (
    <div className="flex flex-row relative gap-x-2 overflow-x-auto">
      <table
        ref={tableRef}
        className="w-full border-collapse my-4 shadow-sm"
        {...props}
      >
        {children}
      </table>
      <div className="my-4">
        <button
          onClick={onCopy}
          disabled={isCopied}
          className={twMerge(
            'text-primary-500 dark:text-primary-400',
            isCopied
              ? ''
              : 'hover:text-primary-600 dark:hover:text-primary-300',
          )}
        >
          {isCopied ? (
            <HiOutlineCheck className="w-4 h-4" />
          ) : (
            <HiOutlineClipboard className="w-4 h-4" />
          )}
        </button>
      </div>
    </div>
  )
}

export default Table
